import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    companyDetailListLoading: false,
    companyDetailListSuccess: null,
    companyDetailListError: '',
    editCompanyDetailLoading: false,
    editCompanyDetailSuccess: null,
    editCompanyDetailError: '',
}

export const companyDetailSlice = createSlice ({
    name: 'companyDetail',
    initialState,
    reducers: {
        setCompanyDetailListLoading: (state, action) => {
            state.companyDetailListLoading = true;
            state.companyDetailListSuccess = null;
            state.companyDetailListError = '';
        },
        setCompanyDetailListSuccess: (state, action) => {
            state.companyDetailListLoading = false;
            state.companyDetailListSuccess = action.payload;
            state.companyDetailListError = '';
        },
        setCompanyDetailListError: (state, action) => {
            state.companyDetailListLoading = false;
            state.companyDetailListSuccess = null;
            state.companyDetailListError = action.payload;
        },
        setEditCompanyDetailsLoading: (state, action) => {
            state.editCompanyDetailLoading = true;
            state.editCompanyDetailSuccess = null;
            state.editCompanyDetailError = '';
        },
        setEditCompanyDetailsSuccess: (state, action) => {
            state.editCompanyDetailLoading = false;
            state.editCompanyDetailSuccess = action.payload;
            state.editCompanyDetailError = '';
        },
        setEditCompanyDetailsError: (state, action) => {
            state.editCompanyDetailLoading = false;
            state.editCompanyDetailSuccess = null;
            state.editCompanyDetailError = null;
        }

    }
})

export const {setCompanyDetailListLoading, setCompanyDetailListSuccess, setCompanyDetailListError, setEditCompanyDetailsLoading, setEditCompanyDetailsSuccess, setEditCompanyDetailsError } = companyDetailSlice.actions

export default companyDetailSlice.reducer